var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewIconChatbot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22134_51663)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_22134_51663)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_22134_51663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9975 8.73172C48.3153 8.73172 49.5186 8.36456 50.5156 7.50404C50.5156 7.50404 53.644 3.54562 52.7044 1.89341C52.5554 1.62951 52.1314 1.40004 51.4209 1.2853C43.3648 -0.0112238 40.626 10.4298 40.626 10.4298C40.626 10.4298 41.3021 11.2674 42.5741 11.9443C42.5741 11.9443 46.6652 14.2965 48.7393 13.8605C50.0343 13.5851 50.0114 12.5983 49.8165 11.887C48.9685 11.9902 48.3152 11.5444 47.433 11.1297C48.2466 11.3936 49.0029 11.7493 49.8509 11.864C53.1857 10.1545 50.5041 7.51551 50.5041 7.51551C49.7185 8.383 48.3152 9.08553 46.986 8.74319L46.9975 8.73172Z",
    fill: "url(#paint0_linear_22134_51663)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_22134_51663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.83649 8.74637C5.51864 8.74637 4.31539 8.37921 3.31841 7.51868C3.31841 7.51868 0.18995 3.56027 1.12963 1.90806C1.27861 1.64416 1.70261 1.41469 2.4131 1.29995C10.4692 0.00342464 13.208 10.4445 13.208 10.4445C13.208 10.4445 12.5319 11.2821 11.2599 11.959C11.2599 11.959 7.16882 14.3111 5.09464 13.8751C3.79971 13.5997 3.82263 12.613 4.01744 11.9016C4.86545 12.0049 5.51881 11.559 6.40103 11.1444C5.5874 11.4083 4.83107 11.7639 3.98306 11.8787C0.648334 10.1691 3.32987 7.53016 3.32987 7.53016C4.11548 8.39764 5.51881 9.10017 6.84795 8.75784L6.83649 8.74637Z",
    fill: "url(#paint1_linear_22134_51663)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_iii_22134_51663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1596 13.55C42.9304 7.8705 39.6415 3.65966 33.8888 1.70913C31.4938 0.894502 28.9498 0.527344 25.6609 0.527344C22.0626 0.527344 18.5445 1.67471 17.5475 2.01892C13.1814 3.5564 10.2249 7.00998 9.4227 11.4962C9.19351 12.7583 9.06745 14.0548 9.03307 15.3513C9.01015 16.4872 9.05599 17.6231 9.17059 18.7705C9.21643 19.2409 9.28518 19.6999 9.35394 20.1703C10.2019 25.4826 13.9263 29.3033 19.5873 30.6572C21.4552 31.0932 23.4377 31.3112 25.6494 31.3112C26.7381 31.3112 27.8497 31.2653 29.2821 31.1621C31.1844 31.0129 33.2013 30.5654 35.115 29.8541C39.504 28.2478 42.5179 24.45 42.9877 19.9523C43.0221 19.6081 43.0565 19.2524 43.0794 18.8967C43.1596 17.8067 43.2055 16.6708 43.2055 15.489C43.2055 14.858 43.1825 14.2154 43.1596 13.55Z",
    fill: "url(#paint2_linear_22134_51663)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dif_22134_51663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6477 26.5251C23.8944 26.5251 22.3474 26.3644 20.9149 26.0202C16.6405 24.999 15.3456 22.3027 15.0132 20.2145C14.6465 17.9313 14.6695 15.648 15.0591 13.4565C15.4945 11.0241 17.053 9.22274 19.4481 8.37369C19.9982 8.17863 22.8974 7.21484 25.6592 7.21484C28.3407 7.21484 30.2545 7.47874 32.0536 8.08684C35.5488 9.26863 37.3021 11.4486 37.4396 14.7301C37.5198 16.7495 37.474 18.5738 37.2906 20.3063C37.05 22.6469 35.4915 24.5516 33.1423 25.4121C31.7098 25.9399 30.2201 26.2726 28.8449 26.3759C27.5729 26.4677 26.5874 26.5136 25.6477 26.5136V26.5251ZM23.5506 19.1589C23.5506 19.1589 23.6079 19.1704 23.6423 19.1819L23.5506 19.1589Z",
    fill: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6477 26.5251C23.8944 26.5251 22.3474 26.3644 20.9149 26.0202C16.6405 24.999 15.3456 22.3027 15.0132 20.2145C14.6465 17.9313 14.6695 15.648 15.0591 13.4565C15.4945 11.0241 17.053 9.22274 19.4481 8.37369C19.9982 8.17863 22.8974 7.21484 25.6592 7.21484C28.3407 7.21484 30.2545 7.47874 32.0536 8.08684C35.5488 9.26863 37.3021 11.4486 37.4396 14.7301C37.5198 16.7495 37.474 18.5738 37.2906 20.3063C37.05 22.6469 35.4915 24.5516 33.1423 25.4121C31.7098 25.9399 30.2201 26.2726 28.8449 26.3759C27.5729 26.4677 26.5874 26.5136 25.6477 26.5136V26.5251ZM23.5506 19.1589C23.5506 19.1589 23.6079 19.1704 23.6423 19.1819L23.5506 19.1589Z",
    fill: "url(#paint3_radial_22134_51663)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.7275 15.4397C35.6246 12.8317 34.2405 11.4705 31.644 10.5898C30.0083 10.0407 28.201 9.78906 25.6273 9.78906C23.4997 9.78906 21.0176 10.4754 19.828 10.8872C18.1465 11.482 17.0599 12.6945 16.751 14.4102C16.3735 16.5264 16.3735 18.6654 16.7053 20.7815C17.0827 23.1836 18.8099 24.4075 21.1434 24.9566C23.6828 25.5628 26.2679 25.4827 28.8301 25.2883C30.157 25.1853 31.5067 24.8536 32.7535 24.3961C34.332 23.8127 35.4073 22.6231 35.5788 20.9988C35.7733 19.1572 35.7962 17.2813 35.7275 15.4168V15.4397Z",
    fill: "url(#paint4_linear_22134_51663)",
    stroke: "url(#paint5_linear_22134_51663)",
    strokeWidth: 0.451476
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5498 20.0077C24.5498 19.812 24.7085 19.6533 24.9041 19.6533H27.3137C27.5094 19.6533 27.668 19.812 27.668 20.0077V21.992C27.668 22.8531 26.97 23.5511 26.1089 23.5511C25.2478 23.5511 24.5498 22.8531 24.5498 21.992V20.0077Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5498 20.0077C24.5498 19.812 24.7085 19.6533 24.9041 19.6533H27.3137C27.5094 19.6533 27.668 19.812 27.668 20.0077V21.992C27.668 22.8531 26.97 23.5511 26.1089 23.5511C25.2478 23.5511 24.5498 22.8531 24.5498 21.992V20.0077Z",
    fill: "url(#paint6_linear_22134_51663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1084 21.7568C26.7325 21.7569 27.2695 22.1246 27.5186 22.6543C27.2694 23.1837 26.7332 23.5507 26.1094 23.5508C25.4846 23.5508 24.947 23.183 24.6982 22.6523C24.9477 22.1235 25.4849 21.7568 26.1084 21.7568Z",
    fill: "url(#paint7_linear_22134_51663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.653 15.4268V18.6639C22.653 19.2587 22.1726 19.7391 21.5778 19.7391H21.0974C20.5026 19.7391 20.0107 19.2587 20.0107 18.6639V16.8108H20.9373V15.8843H21.8638V14.9578H20.9373V15.8843H20.0107V15.4268C20.0107 14.832 20.5026 14.3516 21.0974 14.3516H21.5778C22.1726 14.3516 22.653 14.832 22.653 15.4268Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.653 15.4268V18.6639C22.653 19.2587 22.1726 19.7391 21.5778 19.7391H21.0974C20.5026 19.7391 20.0107 19.2587 20.0107 18.6639V16.8108H20.9373V15.8843H21.8638V14.9578H20.9373V15.8843H20.0107V15.4268C20.0107 14.832 20.5026 14.3516 21.0974 14.3516H21.5778C22.1726 14.3516 22.653 14.832 22.653 15.4268Z",
    fill: "url(#paint8_radial_22134_51663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.653 15.4268V18.6639C22.653 19.2587 22.1726 19.7391 21.5778 19.7391H21.0974C20.5026 19.7391 20.0107 19.2587 20.0107 18.6639V16.8108H20.9373V15.8843H21.8638V14.9578H20.9373V15.8843H20.0107V15.4268C20.0107 14.832 20.5026 14.3516 21.0974 14.3516H21.5778C22.1726 14.3516 22.653 14.832 22.653 15.4268Z",
    fill: "url(#paint9_radial_22134_51663)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2637,
    y: 17.0439,
    width: 1.09119,
    height: 1.09119,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.2637,
    y: 17.0439,
    width: 1.09119,
    height: 1.09119,
    fill: "url(#paint10_radial_22134_51663)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.3555,
    y: 15.9541,
    width: 1.09119,
    height: 1.09119,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.3555,
    y: 15.9541,
    width: 1.09119,
    height: 1.09119,
    fill: "url(#paint11_radial_22134_51663)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.4463,
    y: 17.0439,
    width: 1.09119,
    height: 1.09119,
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.4463,
    y: 17.0439,
    width: 1.09119,
    height: 1.09119,
    fill: "url(#paint12_radial_22134_51663)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.4922,
    cy: 20.0123,
    r: 0.50164,
    transform: "rotate(-4.21204 19.4922 20.0123)",
    fill: "url(#paint13_linear_22134_51663)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.7744,
    cy: 19.9869,
    r: 0.50164,
    transform: "rotate(-4.21204 32.7744 19.9869)",
    fill: "url(#paint14_linear_22134_51663)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_iii_22134_51663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9998 28.7843C30.7821 29.5989 30.5071 30.4135 30.1747 31.2167C30.0945 31.4003 29.9112 31.538 29.682 31.5839C27.3213 32.0313 24.9033 32.0313 22.5427 31.5839C22.3135 31.538 22.1301 31.4003 22.0499 31.2167C21.7176 30.4135 21.4425 29.5989 21.2248 28.7843C21.1217 28.3827 21.5113 28.0385 21.9009 28.1532C24.6512 28.899 27.5505 28.899 30.3008 28.1532C30.7019 28.0385 31.08 28.3827 30.9769 28.7843H30.9998Z",
    fill: "url(#paint15_linear_22134_51663)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.2702 6.4154C27.7431 6.4154 27.7087 6.39246 27.617 5.89909C27.2962 4.08625 25.8179 3.09951 24.1906 2.78972C24.076 2.76677 23.95 2.7553 23.8354 2.74382C23.3885 2.67498 23.4228 2.44551 23.4343 2.36519C23.4343 2.23898 23.4343 2.12425 23.4801 1.99804C23.5374 1.78004 23.7552 1.79151 23.8583 1.80298C26.07 1.98656 27.6973 2.91593 28.5796 4.9353C28.7057 5.22214 28.763 5.53193 28.8203 5.83025C28.9234 6.34656 28.8432 6.4154 28.2932 6.4154H28.2702Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2702 6.4154C27.7431 6.4154 27.7087 6.39246 27.617 5.89909C27.2962 4.08625 25.8179 3.09951 24.1906 2.78972C24.076 2.76677 23.95 2.7553 23.8354 2.74382C23.3885 2.67498 23.4228 2.44551 23.4343 2.36519C23.4343 2.23898 23.4343 2.12425 23.4801 1.99804C23.5374 1.78004 23.7552 1.79151 23.8583 1.80298C26.07 1.98656 27.6973 2.91593 28.5796 4.9353C28.7057 5.22214 28.763 5.53193 28.8203 5.83025C28.9234 6.34656 28.8432 6.4154 28.2932 6.4154H28.2702Z",
    fill: "url(#paint16_linear_22134_51663)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1736 6.40237C25.6809 6.40237 25.6923 6.40237 25.5777 5.9549C25.3715 5.20911 24.8329 4.77311 24.0765 4.54364C24.0078 4.52069 23.9276 4.50922 23.8588 4.49774C23.4234 4.40595 23.3546 4.32564 23.4119 3.92406C23.4463 3.68311 23.5723 3.54543 23.8474 3.53395C24.9131 3.51101 25.6923 4.01585 26.2768 4.79606C26.5403 5.14027 26.6893 5.5648 26.8039 6.01227C26.8612 6.25322 26.7466 6.3909 26.4601 6.40237C26.3685 6.40237 26.2768 6.40237 26.1851 6.40237H26.1736Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1736 6.40237C25.6809 6.40237 25.6923 6.40237 25.5777 5.9549C25.3715 5.20911 24.8329 4.77311 24.0765 4.54364C24.0078 4.52069 23.9276 4.50922 23.8588 4.49774C23.4234 4.40595 23.3546 4.32564 23.4119 3.92406C23.4463 3.68311 23.5723 3.54543 23.8474 3.53395C24.9131 3.51101 25.6923 4.01585 26.2768 4.79606C26.5403 5.14027 26.6893 5.5648 26.8039 6.01227C26.8612 6.25322 26.7466 6.3909 26.4601 6.40237C26.3685 6.40237 26.2768 6.40237 26.1851 6.40237H26.1736Z",
    fill: "url(#paint17_linear_22134_51663)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_22134_51663",
    x: 0.953125,
    y: 1.17383,
    width: 51.9277,
    height: 13.7679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.01303
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.506515
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_51663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_22134_51663",
    x: 39.3987,
    y: -1.28072,
    width: 13.4822,
    height: 16.4221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.22727,
    dy: 1.22727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.613636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.22727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_51663",
    result: "effect2_innerShadow_22134_51663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_22134_51663",
    x: -0.274148,
    y: -1.26607,
    width: 13.4822,
    height: 16.4221,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.22727,
    dy: 1.22727
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.613636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.900785 0 0 0 0 0.900785 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.45455
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.22727
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.483398 0 0 0 0 0.483398 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_51663",
    result: "effect2_innerShadow_22134_51663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_iii_22134_51663",
    x: 9.02734,
    y: -1.00356,
    width: 34.1777,
    height: 34.2287,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.53091
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.775729 0 0 0 0 0.439322 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_51663",
    result: "effect2_innerShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.91363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.29636
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_51663",
    result: "effect3_innerShadow_22134_51663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dif_22134_51663",
    x: 12.0505,
    y: 3.16272,
    width: 27.1154,
    height: 25.051,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.675353,
    dy: -2.02606
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01303
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22134_51663",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.675353,
    dy: 0.675353
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.675353
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.507625 0 0 0 0 0.507625 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.844191,
    result: "effect3_foregroundBlur_22134_51663"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_iii_22134_51663",
    x: 21.208,
    y: 26.9827,
    width: 9.79199,
    height: 6.08542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.53091
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.158597 0 0 0 0 0.158597 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.14818
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14818
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.855364 0 0 0 0 0.638409 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_22134_51663",
    result: "effect2_innerShadow_22134_51663"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.765453
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14818
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_22134_51663",
    result: "effect3_innerShadow_22134_51663"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22134_51663",
    x1: 47.2489,
    y1: 2.45144,
    x2: 47.2423,
    y2: 14.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22134_51663",
    x1: 6.58505,
    y1: 2.46609,
    x2: 6.59164,
    y2: 14.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC7B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22134_51663",
    x1: 26.1133,
    y1: 3.86162,
    x2: 26.1133,
    y2: 33.0166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_22134_51663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.3325 4.62599 -5.44418 -13.878 33.3942 13.3871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22134_51663",
    x1: 26.1328,
    y1: 9.04652,
    x2: 26.539,
    y2: 26.8514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.366298,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22134_51663",
    x1: 19.4604,
    y1: 8.80689,
    x2: 30.4914,
    y2: 25.7911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322115,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595864,
    stopColor: "#FFE3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.947115,
    stopColor: "#FFF5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22134_51663",
    x1: 26.1089,
    y1: 20.6667,
    x2: 26.1089,
    y2: 22.8495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE4D50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22134_51663",
    x1: 26.1089,
    y1: 20.3529,
    x2: 26.1089,
    y2: 23.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_22134_51663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.89898 1.29065 -0.632995 -3.87196 22.1783 16.0736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_22134_51663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.89898 1.29065 -0.632995 -3.87196 22.1783 16.0736)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_22134_51663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1588 17.3927) rotate(161.565) scale(0.826646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_22134_51663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2506 16.3029) rotate(161.565) scale(0.826646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_22134_51663",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3414 17.3927) rotate(161.565) scale(0.826646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_22134_51663",
    x1: 19.4922,
    y1: 19.5106,
    x2: 19.4922,
    y2: 20.5139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_22134_51663",
    x1: 32.7744,
    y1: 19.4852,
    x2: 32.7744,
    y2: 20.4885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_22134_51663",
    x1: 26.1128,
    y1: 28.0993,
    x2: 26.1128,
    y2: 38.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EE0033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8D58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_22134_51663",
    x1: 23.7141,
    y1: 2.00961,
    x2: 23.1555,
    y2: 8.7416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_22134_51663",
    x1: 23.5745,
    y1: 3.66478,
    x2: 23.2323,
    y2: 7.84861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFC9C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22134_51663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 31.725,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconChatbot);
export default __webpack_public_path__ + "static/media/new-icon-chatbot.66a35ae6c880ea23d8f2b5977152dff1.svg";
export { ForwardRef as ReactComponent };